import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  userInfo: null,
  authorized: true,
};

const userInfoSlice = createSlice({
  name: 'userinfo',
  initialState,
  reducers: {
    setUserInfo: (state, action) => {
      state.userInfo = action.payload;
    },
    setDeliveryWeightRangesEnabled: (state, action) => {
      if (state?.userInfo?.userProfile?.store) {
        state.userInfo.userProfile.store.delivery_weight_ranges_enabled = action?.payload;
      }
    },
    // updateUserInfo: (state, action) => {
    //   state.userInfo = {...state, ...action.payload};
    // },
    setAuthorized: (state, action) => {
      state.authorized = action.payload;
    },
    updateStoreInfo: (state, action) => {
      if (state.userInfo?.userProfile) {
        state.userInfo.userProfile.store = {
          ...state.userInfo.userProfile.store,
          ...action.payload
        };
      }
    }
  },
});

export const { setUserInfo, setAuthorized, setDeliveryWeightRangesEnabled, updateStoreInfo, /*updateUserInfo*/ } = userInfoSlice.actions;

export default userInfoSlice.reducer;
